import * as React from "react";
import { forwardRef } from "react";
const SvgKeyIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "-6.3 14.6 22.3 11.2", style: {
  enableBackground: "new -6.3 14.6 22.3 11.2"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.7,18.7l-0.1-0.3c-0.8-2.2-2.9-3.7-5.2-3.7c-3,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5c2.3,0,4.4-1.5,5.2-3.7l0.1-0.3h5.2v3h3 v-3h3v-3H4.7z M-0.6,22.6c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4C1.7,21.5,0.7,22.6-0.6,22.6z" }));
const ForwardRef = forwardRef(SvgKeyIcon);
export { ForwardRef as ReactComponent };
